type Mark = {
  type: string;
  attrs?: Record<string, string>;
};

type Node = {
  type: string;
  content?: Node[];
  text?: string;
  marks?: Mark[];
  attrs?: Record<string, string | number>;
};

function applyMarks(text: string, marks?: Mark[]): string {
  if (!marks) return text;

  let result = text;
  for (const mark of marks) {
    switch (mark.type) {
      case 'bold':
        result = `**${result}**`;
        break;
      case 'italic':
        result = `*${result}*`;
        break;
      case 'strike':
        result = `~~${result}~~`;
        break;
      case 'link':
        result = `[${result}](${mark.attrs?.href ?? ''})`;
        break;
    }
  }
  return result;
}

function renderInline(nodes?: Node[]): string {
  if (!nodes) return '';
  return nodes
    .map((node) => {
      if (node.type === 'text') return applyMarks(node.text ?? '', node.marks);
      if (node.type === 'hardBreak') return '\n';
      if (node.type === 'image')
        return `![${node.attrs?.alt ?? ''}](${node.attrs?.src ?? ''})`;
      return '';
    })
    .join('');
}

function renderNode(node: Node): string {
  switch (node.type) {
    case 'doc':
      return (node.content ?? []).map(renderNode).join('\n\n');

    case 'paragraph':
      return renderInline(node.content);

    case 'heading': {
      const level = Number(node.attrs?.level ?? 1);
      const prefix = '#'.repeat(level);
      return `${prefix} ${renderInline(node.content)}`;
    }

    case 'bulletList':
      return (node.content ?? []).map(renderNode).join('\n');

    case 'listItem': {
      const inner = (node.content ?? []).map(renderNode).join('\n  ');
      return `- ${inner}`;
    }

    case 'codeBlock': {
      const lang = node.attrs?.language ?? '';
      const code = renderInline(node.content);
      return `\`\`\`${lang}\n${code}\n\`\`\``;
    }

    case 'image':
      return `![${node.attrs?.alt ?? ''}](${node.attrs?.src ?? ''})`;

    default:
      return renderInline(node.content);
  }
}

export function getMarkdown(answerJson?: string): string {
  if (!answerJson) return '';

  try {
    return renderNode(JSON.parse(answerJson));
  } catch {
    return '';
  }
}
